import React, { useEffect } from 'react'
import BibliographyB1 from '@chegg-wt/core/components/SEO/BibliographyB1'
import SEOTitle from '@chegg-wt/core/components/SEOTitle'
import { connect } from 'react-redux'
import { AppState } from '@chegg-wt/core/state'
import useQueryStringStyleUpdate from '@chegg-wt/core/hooks/useQueryStringStyleUpdate'
import BibliographyContainer from '@chegg-wt/core/components/BibliographyContainer'
import { setAsCurrentProject } from '@chegg-wt/core/state/currentProject/actions'
import { initializedSelector } from '@chegg-wt/core/state/app/selectors'
import { projectNameSelector } from '@chegg-wt/core/state/currentProject/selectors'
import { authModalExpFlagSelector } from '@chegg-wt/core/state/createCitation/selectors'
import { isGuestSelector } from '@chegg-wt/core/state/user/selectors'
import { AuthModalOrigin } from '@chegg-wt/core/components/Modals/AuthModal/types'
import { useRoutesContext } from '@chegg-wt/core/components/RoutesContext'
import { startAuthFlow } from '@chegg-wt/core/state/user/actions'
import {
  BibliographyLayoutDispatchProps,
  BibliographyLayoutProps,
  BibliographyLayoutStateProps,
} from './types'
import * as Styled from './styled'

export { BibliographyLayoutTop } from './styled'

export const BibliographyLayout: React.FC<BibliographyLayoutProps> = ({
  copy,
  siteName,
  bibliographyName,
  projectId,
  initialized,
  setAsCurrentProject,
  startAuthFlow,
  authModalExpFlag,
  isGuestUser,
}) => {
  const showAuthModal = authModalExpFlag && isGuestUser
  useQueryStringStyleUpdate()
  const { toUpgrade } = useRoutesContext()
  useEffect(() => {
    if (projectId && initialized) setAsCurrentProject(projectId)
  }, [initialized])

  const onUpgradeClick = () => {
    if (showAuthModal) {
      startAuthFlow({
        defaultFlow: 'signup',
        origin: AuthModalOrigin.BIBLIOGRAPHY_PAGE,
        redirectTo: toUpgrade(),
      })
    }
  }

  return (
    <>
      <SEOTitle title={`${bibliographyName} | ${siteName}`} enable={!!siteName} />
      <Styled.Layout>
        <Styled.Container>
          <BibliographyContainer copy={copy} />
          {!!copy?.bibliographyB1 && (
            <BibliographyB1
              showAuthModal={showAuthModal}
              onUpgradeClick={onUpgradeClick}
              copy={copy?.bibliographyB1}
            />
          )}
        </Styled.Container>
      </Styled.Layout>
    </>
  )
}

const mapStateToProps = (state: AppState) => ({
  bibliographyName: projectNameSelector(state),
  initialized: initializedSelector(state),
  authModalExpFlag: authModalExpFlagSelector(state),
  isGuestUser: isGuestSelector(state),
})

const mapDispatchToProps = {
  setAsCurrentProject,
  startAuthFlow,
}

export default connect<BibliographyLayoutStateProps, BibliographyLayoutDispatchProps>(
  mapStateToProps,
  mapDispatchToProps
)(BibliographyLayout)
